import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import Login from 'src/content/pages/Auth/Login/Cover';
import VerifyEmail from 'src/components/VerifyEmail';

const Authenticated = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  useEffect(() => {
    if (!auth.isAuthenticated) {
      setRequestedLocation((current) => current || location.pathname);
      return;
    }

    if (requestedLocation && location.pathname === requestedLocation) {
      setRequestedLocation(null);
    }
  }, [auth.isAuthenticated, location.pathname, requestedLocation]);

  if (!auth.isAuthenticated) {
    return <Login />;
  }

  if (Number(auth.user?.accountVersion || 1) >= 2 && !auth.user?.emailVerified) {
    return <VerifyEmail />;
  }

  if (requestedLocation && location.pathname !== requestedLocation) {
    return <Navigate to={requestedLocation} replace />;
  }

  return <>{children}</>;
};

Authenticated.propTypes = {
  children: PropTypes.node
};

export default Authenticated;
